module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-easy-invoicing@2x-63c6db549c73caddc8ec007e46bf96a0.png";